import { render, staticRenderFns } from "./video-viewer.vue?vue&type=template&id=1972387c&"
import script from "./video-viewer.vue?vue&type=script&lang=js&"
export * from "./video-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports